import { FaArrowRight } from 'react-icons/fa';
import Button from '@/components/elements/Button';
import { SubscribeButtonLabels, SubscribeButtonText } from '@/constants/constants';
import { formatCurrencyToMajor } from '@/utils/formatCurrency';
import { useMemo } from 'react';

interface SubscribeButtonProps {
  price: number;
  currency: string;
  onClick: () => void;
  trialEnabled?: boolean;
  isSubscribed?: boolean;
  hasUserCompletedTrial?: boolean;
}

function SubscribeButton({
  price,
  currency,
  onClick,
  trialEnabled = false,
  isSubscribed = false,
  hasUserCompletedTrial = false,
}: SubscribeButtonProps) {
  const getButtonText = useMemo(() => {
    return isSubscribed
      ? SubscribeButtonText.Unsubscribe
      : trialEnabled
        ? hasUserCompletedTrial
          ? SubscribeButtonText.Subscribe
          : SubscribeButtonText.FreeTrial
        : SubscribeButtonText.Subscribe;
  }, [isSubscribed, trialEnabled, hasUserCompletedTrial]);

  const labelText = isSubscribed ? (
    SubscribeButtonLabels.AccessRetained
  ) : (
    <>
      {trialEnabled && !hasUserCompletedTrial && SubscribeButtonLabels.TrialThen}{' '}
      <strong>
        {formatCurrencyToMajor(price, currency)}
        {SubscribeButtonLabels.PerMonth}
      </strong>{' '}
      &middot; {SubscribeButtonLabels.CancelAnytime}
    </>
  );

  return (
    <div className='flex flex-col items-center justify-center'>
      <Button
        onClick={onClick}
        className='md:w-full'
        variant='gradient'
        buttonText={getButtonText}
        data-cy='subscribe-button'
        hoverText={!isSubscribed ? SubscribeButtonLabels.AccessResearchNow : undefined}
      >
        {!isSubscribed && <FaArrowRight size={16} className='ml-2 font-normal' />}
      </Button>

      <span className={`z-10 d-block normal-case text-sm w-[234px] text-center ${isSubscribed && 'w-[200px]'}`}>
        {labelText}
      </span>
    </div>
  );
}

export default SubscribeButton;
